import { type PromoData } from '@hungryroot/rest/api/get_cancel_winback/get';

interface Message {
  [key: string]: PromoData | boolean;
}

export function iosPostMessage(message: Message) {
  return window?.webkit?.messageHandlers?.observer?.postMessage(message);
}
